import React from "react";
import { Box, Card, CardActionArea, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { contentFeatures } from "./contentFeatures";

const ContentHome: React.VFC = () => {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="70vh" style={{ gap: 24 }}>
      {contentFeatures.map(({ area, label, Icon }) => (
        <Card key={area} style={{ width: 220 }}>
          <CardActionArea component={Link} to={area}>
            <Box display="flex" flexDirection="column" alignItems="center" p={4} style={{ gap: 12 }}>
              <Icon />
              <Typography variant="h6" align="center">
                {t(label)}
              </Typography>
            </Box>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
};

export default ContentHome;
